<template>
  <v-card>
    <v-tabs
      v-model="tab"
      background-color="blue-grey lighten-5"
    >
      <v-tab key="boat_config">Configs</v-tab>
      <v-tab key="boat_order">Orders</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab" class="mt-4">
      <v-tab-item key="boat_config">
        <r-boat-config-page/>
      </v-tab-item>
      <v-tab-item key="boat_order">
        <r-boat-order-page/>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>

import RBoatOrderPage from "@/modules/redactor/views/boats/r-boat-order-page";
import RBoatConfigPage from "@/modules/redactor/views/boats/r-boat-config-page";

export default {
  name: "r-boat-page",
  components: {RBoatConfigPage, RBoatOrderPage},
  data: () => ({
    tab: null
  })
}

</script>
